import { Component, type OnInit, computed, inject, output, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
    type AdvizeoModalButton,
    type AdvizeoModalComponent,
    injectAdvizeoModalInput
} from '../../advizeo-modal-spawner/advizeo-modal-spawner.component';

interface HelpMeModalInput {
    title: string;
    text: string;
}
@Component({
    styleUrls: ['./help-me-modal.scss'],
    selector: 'help-me-modal',
    templateUrl: 'help-me-modal.html'
})
export class HelpMeModalComponent implements AdvizeoModalComponent<HelpMeModalInput, null>, OnInit {
    private _translateService = inject(TranslateService);

    title = signal('');
    isDismissable = signal(true);
    buttons = signal<AdvizeoModalButton[]>([]);
    input = injectAdvizeoModalInput<HelpMeModalInput>();
    close = output();

    text = computed(() => this.input().text);

    ngOnInit() {
        this.title.set(this.input().title ? this.input().title : this._translateService.instant('STUFF.HELP'));
    }
}
